import { api } from '@/shared/api';
import type { UpdateApplicationDetailRequest, UpdateApplicationDetailResponse } from '../model/types';

/**
 * 管理者向け申込更新API
 *
 * @param applicationId 申込ID
 * @param body 更新リクエストボディ
 * @returns 更新された申込ID
 */
export const updateApplicationDetail = async (
    applicationId: string,
    body: UpdateApplicationDetailRequest
): Promise<UpdateApplicationDetailResponse> => {
    return api.patch('/applications/{application_id}', {
        path: { application_id: applicationId },
        body,
    });
};
